import codeHighlighter from 'toxilibs/code_highlighter.js'

codeHighlighter.setTheme('bright')


// a blank line of code becomes a block: the css sets its height (shorter on phones)
function markBlankLines ($pre) {
    const code = $pre.find('code')[0]
    code.innerHTML = code.innerHTML.replace(/\n([ \t]*\n)+/g, '\n<span class="blank_line"></span>')
    return $pre
}


export default function highlightCode (source, language) {
    return markBlankLines(codeHighlighter(source, language))
}
